/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscalemoodshiftsweak4Inputs */



/**
* | output |
* | --- |
* | "Spotting mood shifts in real time is not easy for you — building up your observation skills will help you track those changes better." |
*
* @param {Eisubscalemoodshiftsweak4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscalemoodshiftsweak4 = /** @type {((inputs?: Eisubscalemoodshiftsweak4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscalemoodshiftsweak4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Spotting mood shifts in real time is not easy for you — building up your observation skills will help you track those changes better.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No te resulta fácil notar los cambios de ánimo en tiempo real — desarrollar la observación te ayudará a seguirlos mejor.")
	return /** @type {LocalizedString} */ ("Тебе непросто замечать сдвиги в настроении в реальном времени — развитие наблюдательности поможет лучше отслеживать эти изменения.")
});
export { eisubscalemoodshiftsweak4 as "eiSubscaleMoodShiftsWeak" }